import {
  React,
  PropTypes,
  LazyLoadImage
} from '../libraries'
import imgnotfound from '../assets/images/imgnotfound.png'

const handleError = (ev) => {
  ev.target.src = imgnotfound
}

export const CardImage = ({ id, image, title, styleImg }) => {
  return (
    <LazyLoadImage
      key={id}
      alt={title}
      src={image}
      onError={handleError}
      className={styleImg ? 'img-card-rounded' : 'img-detail'}
    />
  )
}

CardImage.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  image: PropTypes.string,
  styleImg: PropTypes.string
}

CardImage.defaultValue = {
  id: null,
  title: 'Not set',
  image: imgnotfound,
  styleImg: 'img-card-rounded'
}
